module.exports = __webpack_public_path__ + "img/dec4_03.557c823c.jpeg";